import React from "react";

import { Timeline as AntTimeline } from "antd";

export const Timeline = ({ className, items, mode, pending = false, pendingDot }) => (
  <AntTimeline
    className={className}
    mode={mode}
    pending={pending}
    pendingDot={pendingDot}
    items={items.map((item) => ({
      dot: item.icon,
      children: item.content,
    }))}
  />
);

export default Timeline;
